<template>
  <f-box 
    class="stat p-7 has-no-col-gap" 
    grid
  >
    <div class="stat-ingoings-chart is-col-12 is-row-10 min-height-200">
      <div class="chart-container" ref="chartContainer"></div>
    </div>

    <div class="is-col-12">
      <f-select 
        v-model="currentSet"
        :options="setOptions"
        label="label"
        value="value"
        long
      >
        <template #header>
          {{ setMap[currentSet] }}
        </template>
      </f-select>
    </div>
    
    <div class="is-col-12 is-grid">
      <div class="is-col-6">
        <f-datepicker v-model="from"></f-datepicker>
      </div>

      <div class="is-col-6">
        <f-datepicker v-model="to"></f-datepicker>
      </div>
    </div>
  </f-box>
</template>

<script>
import { onMounted, nextTick, ref, onUnmounted, computed, watch, reactive, toRefs } from 'vue'
import useStatistics from '@composables/statistics/use-statistics.js'
import dayjs from 'dayjs'
import Chart from 'apexcharts'

export default {
  setup() {
    const setMap = {
      'subscriptions': 'Plans',
      'free_codes': 'Codes périodes gratuites',
      'paid_codes': 'Codes abonnements',
    }

    const state = reactive({
      to: new Date(),
      from: new Date(),
      currentSet: 'subscriptions',
      setMap: setMap,
      setOptions: [{
        label: setMap['subscriptions'],
        value: 'subscriptions'
      }, {
        label: setMap['free_codes'],
        value: 'free_codes'
      }, {
        label: setMap['paid_codes'],
        value: 'paid_codes'
      }]
    })

    state.from.setYear(state.to.getFullYear() - 1)

    const { subscriptionsPlans, paidCodes, freeCodes } = useStatistics(state)

    const currentSetSource = computed(() => 
      state.currentSet === 'subscriptions' ? 
        subscriptionsPlans.value 
        : state.currentSet === 'free_codes' 
        ? freeCodes.value
        : paidCodes.value
    )

    const chartContainer = ref(null)
    const chartOptions = computed(() => {
      return {
        series: currentSetSource.value.map(plan => plan.total),
        labels: currentSetSource.value.map(plan => plan.name),
        chart: {
          type: 'donut',
          width: state.currentSet === 'subscriptions' 
            ? (chartContainer.value?.parentNode?.offsetWidth || 100) - 2
            : 262,
          height: state.currentSet === 'subscriptions' 
            ? (chartContainer.value?.parentNode?.offsetHeight || 100) - 20
            : 255,
        },
        dataLabels: {
          enabled: true
        },
        legend: {
          show: state.currentSet === 'subscriptions',
          formatter: function(val, opts) {
            return val + ' - ' + opts.w.globals.series[opts.seriesIndex]
          },
          position: 'bottom',
          horizontalAlign: 'left',
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                value: {
                  show: true,
                }
              },
            },
          }
        }
      }
    })

    function removeMonths(date, months) {
      date.setMonth(date.getMonth() - months)
      return date
    }

    const optionsData = {
      'Tout': '',
      '12 mois': 11,
      '6 mois': 5,
      '3 mois': 2
    }

    function updateOptionsData (option) {
      state.from = option === '' ? new Date(2016, 0, 1) : removeMonths(new Date(), option),
      state.to = new Date()
    }

    let chart = null;

    onMounted(() => {
      nextTick(() => {
        chart = new Chart(chartContainer.value, chartOptions.value)

        chart.render()
      })
    })

    onUnmounted(() => {
      chart && chart.destroy()
    })

    watch(
      () => chartOptions.value,
      () => chart && chart.updateOptions(chartOptions.value)
    )

    return {
      ...toRefs(state),
      chartContainer,
      updateOptionsData,
      optionsData,
    }
  }
}
</script>
